const DETAIL_SLUG_DELIMITER = '--';

const IDX_PATTERN =
  /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

export const safeDecodeURIComponent = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

export const extractIdx = (rawSlug: string): string => {
  if (!rawSlug) return '';

  const decodedSlug = safeDecodeURIComponent(rawSlug);
  const uuid = decodedSlug.match(IDX_PATTERN)?.[0];
  if (uuid) return uuid;

  const parts = decodedSlug.split(DETAIL_SLUG_DELIMITER);

  return parts[parts.length - 1]?.trim() ?? '';
};

// Must stay byte-for-byte identical to the backend Java `cleanTitle` so that
// client-emitted canonical URLs match the URLs the backend writes into sitemap
// shards. Any drift produces split SEO signals.
export const cleanTitle = (title: string | null | undefined): string => {
  if (title === null || title === undefined) return '';

  if (title.trim().length === 0) return '';

  const stripped = title.replace(/[^0-9가-힣a-zA-Z ]/g, '');

  return stripped.trim().replace(/ +/g, '-');
};

export const buildDetailSlug = (
  idx: string,
  title?: string | null,
  serverSlug?: string | null,
): string => {
  const trimmedServerSlug = serverSlug?.trim();

  if (trimmedServerSlug && extractIdx(trimmedServerSlug) === idx) {
    return trimmedServerSlug;
  }

  const cleaned = cleanTitle(title);

  if (cleaned === '') return idx;

  return `${encodeURIComponent(cleaned)}${DETAIL_SLUG_DELIMITER}${idx}`;
};
